export const labelMap = {
    situation: '現在の状況',
    prefectureCity: '住所',
    prefecture: '都道府県',
    city: '市区町村',
    name: '氏名',
    nameKana: '氏名（カナ）',
    birthday: '誕生日',
    tel: '電話番号',
    lineId: 'LINE ID',
    email: 'メールアドレス',
    password: 'パスワード',
}

export const resumeLabelMap = {
    companyName: '会社・店舗名',
    brandName: 'ブランド・系列名',
    storeName: '店舗名',
    workStartDate: '勤務開始',
    workEndDate: '勤務終了',
    employment: '雇用形態',
    genre: '料理ジャンル',
    occupation: '仕事内容',
    detailedJobDetails: '詳細な職務内容',
}
